import Icon from '@mui/material/Icon';
import intl from 'react-intl-universal';

// import CreateIcon from '@mui/icons-material/Create';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import GroupIcon from '@mui/icons-material/Group';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PaidIcon from '@mui/icons-material/Paid';

// view components
import New from 'views/New';
import IssueDetails from 'views/IssueDetails';
import KenshinIssueDetails from 'views/IssueDetails/kenshinDetails';
import ReceivedHistory from 'views/History/ReceivedHistory';
import SentHistory from 'views/History/SentHistory';
import BillingForReceivedTasks from 'views/Billing/ReceivedBilling';
import BillingForSentCases from 'views/Billing/SentBilling';
import Kanban from 'views/Kanban';
import Manual from 'views/Manual';
import PaidWage from 'views/Wages/PaidWage';
import MyWage from 'views/Wages/MyWage';

import ServiceTerms from 'views/ServiceTerms';
import OrganizationSettings from 'views/OrganizationSetttings';
import OrganizationLogs from 'views/OrganizationLogs';
import Friends from 'views/Contacts';

// Kenshin page components
import NewKenshin from 'views/New/Kenshin';
import KanbanKenshin from 'views/Kanban/Kenshin';
import ReceivedAssignmentKenshin from 'views/Kenshin/Assignment';
import ReceivedKenshin from 'views/Kenshin/ReceivedKenshin';
import SentKenshin from 'views/Kenshin/SentKenshin';
import Viewer from 'views/Kenshin/Assignment/components/Viewer';

import { MenuOptionsAll } from 'shared/constants/menuOptions';
import {
  ROUTES,
  // ROUTE_TITLE
} from 'shared/constants/routes';
import { USER_DATA, UserType } from 'shared/constants/users';
import localData from 'utils/localData';
import { Privilege, PrivilegeStatus } from 'shared/constants/privilege';
import { ISSUE_LIST_TYPE } from 'shared/constants/issueList';
import logger from 'utils/logger';

const log = logger.createLogger('Routes');

export const getStaticMenuContents = () => {
  const hasAffiliation = !!localData.get(USER_DATA.CURRENT_ORGANIZATION);

  if (!hasAffiliation) {
    return [
      {
        type: 'item',
        name: intl.get('dashboard_button_service_terms'),
        key: ROUTES.SERVICE_TERMS,
        icon: <Icon fontSize="medium">handshake</Icon>,
        route: '/dashboard/service-terms',
        component: <ServiceTerms />,
      },
    ];
  }

  const menuContentForNew = {
    type: 'item',
    name: intl.get('dashboard_button_new'),
    key: 'new-regular',
    route: '/dashboard/new/new-regular',
    component: <New />,
    icon: <Icon fontSize="medium">create</Icon>,
  };

  // For kenshin New priviledges
  const menuContentForKenshinNew = {
    type: 'item',
    name: intl.get('dashboard_button_new_kenshin'),
    key: 'new-kenshin',
    route: '/dashboard/new/new-kenshin',
    component: <NewKenshin />,
    icon: <Icon fontSize="medium">create</Icon>,
  };

  // For Kenshin task management
  const menuContentForTaskManagement = {
    type: 'item',
    name: intl.get('dashboard_button_task_management'),
    key: 'task-management-regular',
    route: '/dashboard/task-management/task-management-regular',
    component: <Kanban />,
    icon: <ViewKanbanIcon />,
    children: [
      {
        name: 'kanbanIssueDetails',
        key: 'kanbanIssueDetails',
        route:
          '/dashboard/task-management/task-management-regular/issues/:issueId',
        component: <IssueDetails />,
      },
    ],
  };

  const menuContentForKenshinTaskManagement = {
    type: 'item',
    name: intl.get('dashboard_button_task_management_kenshin'),
    key: 'task-management-kenshin',
    route: '/dashboard/task-management/task-management-kenshin',
    component: <KanbanKenshin />,
    icon: <ViewKanbanIcon />,
    children: [
      {
        name: 'kanbanIssueDetailsKenshin',
        key: 'kanbanIssueDetailsKenshin',
        route:
          '/dashboard/task-management/task-management-kenshin/issues/:issueId',
        component: <KenshinIssueDetails />,
      },
    ],
  };

  // For Kenshin priviledges
  const menuContentForKenshinHistory = {
    type: 'collapse',
    name: intl.get('dashboard_button_history'),
    key: 'history-kenshin',
    icon: <AssignmentIcon />,
    children: [
      {
        name: intl.get('dashboard_button_history_received_kenshin'),
        key: 'received-kenshin',
        route: '/dashboard/history/received-kenshin',
        component: <ReceivedKenshin type={ISSUE_LIST_TYPE.TASK_LIST} />,
        icon: <AssignmentIcon />,

        children: [
          {
            name: 'receivedIssueDetailsKenshin',
            key: 'receivedIssueDetailsKenshin',
            route: '/dashboard/history/received-kenshin/issues/:issueId',
            component: <KenshinIssueDetails />,
          },
        ],
      },
      {
        name: intl.get('dashboard_button_history_sent_kenshin'),
        key: 'sent-kenshin',
        route: '/dashboard/history/sent-kenshin',
        component: <SentKenshin type={ISSUE_LIST_TYPE.TASK_LIST} />,
        icon: <AssignmentIcon />,

        children: [
          {
            name: 'issueDetailsSentKenshin',
            key: 'issueDetailsSentKenshin',
            route: '/dashboard/history/sent-kenshin/issues/:issueId',
            component: <KenshinIssueDetails />,
          },
        ],
      },
    ],
  };

  const menuContentForHistory = {
    type: 'collapse',
    name: intl.get('dashboard_button_history'),
    key: 'history',
    icon: <AssignmentIcon />,
    children: [
      {
        name: intl.get('dashboard_button_history_received'),
        key: 'received',
        route: '/dashboard/history/received',
        component: <ReceivedHistory type={ISSUE_LIST_TYPE.TASK_LIST} />,
        children: [
          {
            name: 'receivedIssueDetails',
            key: 'receivedIssueDetails',
            route: '/dashboard/history/received/issues/:issueId',
            component: <IssueDetails />,
          },
          {
            name: 'receivedIssuePreviousDetails',
            key: 'receivedIssuePreviousDetails',
            route:
              '/dashboard/history/received/issues/:issueId/previous-issue/:prevIssueId',
            component: <IssueDetails />,
          },
        ],
      },
      {
        name: intl.get('dashboard_button_history_sent'),
        key: 'sent',
        route: '/dashboard/history/sent',
        component: <SentHistory type={ISSUE_LIST_TYPE.TASK_LIST} />,
        children: [
          {
            name: 'sentIssueDetails',
            key: 'sentIssueDetails',
            route: '/dashboard/history/sent/issues/:issueId',
            component: <IssueDetails />,
          },
          {
            name: 'sentIssuePreviousDetails',
            key: 'sentIssuePreviousDetails',
            route:
              '/dashboard/history/sent/issues/:issueId/previous-issue/:prevIssueId',
            component: <IssueDetails />,
          },
        ],
      },
    ],
  };

  const menuContentForAssignment = {
    type: 'collapse',
    name: intl.get('dashboard_button_assignment'),
    key: 'assignment',
    icon: <AssignmentIcon />,
    children: [
      {
        name: intl.get('dashboard_button_assignment_received'),
        key: 'received',
        route: '/dashboard/assignment/received',
        component: <ReceivedHistory type={ISSUE_LIST_TYPE.ASSIGNMENT} />,
        children: [
          {
            name: 'receivedAssignmentIssueDetails',
            key: 'receivedAssignmentIssueDetails',
            route: '/dashboard/assignment/received/issues/:issueId',
            component: <IssueDetails />,
          },
        ],
      },
      {
        name: intl.get('dashboard_button_assignment_sent'),
        key: 'sent',
        route: '/dashboard/assignment/sent',
        component: <SentHistory type={ISSUE_LIST_TYPE.ASSIGNMENT} />,
        children: [
          {
            name: 'sentAssignmentIssueDetails',
            key: 'sentAssignmentIssueDetails',
            route: '/dashboard/assignment/sent/issues/:issueId',
            component: <IssueDetails />,
          },
        ],
      },
      {
        name: intl.get('dashboard_button_assignement_received_kenshin'),
        key: 'received-kenshin',
        route: '/dashboard/assignment/received-kenshin',
        component: <ReceivedAssignmentKenshin />,
        children: [
          {
            name: 'receivedAssignmentKenshinViewer',
            key: 'receivedAssignmentKenshinViewer',
            route: '/dashboard/assignment/received-kenshin/viewer/:caseId',
            component: <Viewer />,
          },
        ],
      },
    ],
  };

  const menuContentForContacts = {
    type: 'collapse',
    name: intl.get('dashboard_button_contacts'),
    key: 'contacts',
    icon: <GroupIcon />,
    children: [
      {
        name: intl.get('dashboard_button_friends'),
        key: 'friends',
        route: '/dashboard/contacts/friends',
        component: <Friends />,
        icon: <GroupIcon />,
      },
    ],
  };

  const menuContentForBilling = {
    type: 'collapse',
    name: intl.get('dashboard_button_billing'),
    key: 'billing',
    icon: <Icon fontSize="medium">currency_yen</Icon>,
    children: [
      {
        name: intl.get('dashboard_button_billing_received'),
        key: 'received-billing',
        route: '/dashboard/billing/received-billing',
        component: <BillingForReceivedTasks />,
        children: [
          {
            name: 'receivedSeimitsuIssueDetails',
            key: 'receivedSeimitsuIssueDetails',
            route:
              '/dashboard/billing/received-billing/seimitsu/issues/:issueId',
            component: <IssueDetails />,
          },
          {
            name: 'receivedKenshinIssueDetails',
            key: 'receivedKenshinIssueDetails',
            route:
              '/dashboard/billing/received-billing/kenshin/issues/:issueId',
            component: <KenshinIssueDetails />,
          },
        ],
      },
      {
        name: intl.get('dashboard_button_billing_sent'),
        key: 'sent-billing',
        route: '/dashboard/billing/sent-billing',
        component: <BillingForSentCases />,
        children: [
          {
            name: 'sentSeimitsuIssueDetails',
            key: 'sentSeimitsuIssueDetails',
            route: '/dashboard/billing/sent-billing/seimitsu/issues/:issueId',
            component: <IssueDetails />,
          },
          {
            name: 'sentKenshinIssueDetails',
            key: 'sentKenshinIssueDetails',
            route: '/dashboard/billing/sent-billing/kenshin/issues/:issueId',
            component: <KenshinIssueDetails />,
          },
        ],
      },
    ],
  };

  const menuContentForPaidWage = {
    type: 'collapse',
    name: intl.get('dashboard_button_paid_wage'),
    key: 'paid-wage',
    icon: <PaidIcon />,
    children: [
      {
        name: intl.get('dashboard_button_paid_wage'),
        key: 'paid-wage',
        icon: <PaidIcon />,
        route: '/dashboard/paid-wage',
        component: <PaidWage />,
        children: [
          {
            name: 'paidWageSeimitsuIssueDetails',
            key: 'paidWageSeimitsuIssueDetails',
            route: '/dashboard/paid-wage/seimitsu/issues/:issueId',
            component: <IssueDetails />,
          },
          {
            name: 'paidWageKenshinIssueDetails',
            key: 'paidWageKenshinIssueDetails',
            route: '/dashboard/paid-wage/kenshin/issues/:issueId',
            component: <KenshinIssueDetails />,
          },
        ],
      },
    ],
  };

  const menuContentForMyWage = {
    type: 'collapse',
    name: intl.get('dashboard_button_my_wage'),
    key: 'my-wage',
    icon: <PaidIcon />,
    children: [
      {
        name: intl.get('dashboard_button_my_wage'),
        key: 'my-wage',
        route: '/dashboard/my-wage',
        component: <MyWage />,
        icon: <PaidIcon />,
        children: [
          {
            name: 'myWageSeimitsuIssueDetails',
            key: 'myWageSeimitsuIssueDetails',
            route: '/dashboard/my-wage/seimitsu/issues/:issueId',
            component: <IssueDetails />,
          },
          {
            name: 'myWageKenshinIssueDetails',
            key: 'myWageKenshinIssueDetails',
            route: '/dashboard/my-wage/kenshin/issues/:issueId',
            component: <KenshinIssueDetails />,
          },
        ],
      },
    ],
  };

  const menuContentForOrganizationSettings = {
    type: 'item',
    name: intl.get('dashboard_button_organization_settings'),
    key: 'settings',
    icon: <Icon fontSize="medium">settings</Icon>,
    route: '/dashboard/settings',
    component: <OrganizationSettings />,
  };

  const menuContentForOrganizationLogs = {
    type: 'item',
    name: intl.get('dashboard_button_organization_logs'),
    key: 'logs',
    icon: <Icon fontSize="medium">assignment</Icon>,
    route: '/dashboard/logs',
    component: <OrganizationLogs />,
  };

  const menuContentForManual = {
    type: 'item',
    name: intl.get('dashboard_button_manual'),
    key: 'manual',
    icon: <Icon fontSize="medium">lightbulb</Icon>,
    route: '/dashboard/manual',
    component: <Manual />,
  };

  const menuContentForServiceTerms = {
    type: 'item',
    name: intl.get('dashboard_button_service_terms'),
    key: 'service-terms',
    icon: <Icon fontSize="medium">handshake</Icon>,
    route: '/dashboard/service-terms',
    component: <ServiceTerms />,
  };

  const menuOptionsToContent = {
    [MenuOptionsAll.NEW]: menuContentForNew,
    [MenuOptionsAll.NEW_KENSHIN]: menuContentForKenshinNew,
    [MenuOptionsAll.TASKMANAGEMENT]: menuContentForTaskManagement,
    [MenuOptionsAll.TASKMANAGEMENT_KENSHIN]:
      menuContentForKenshinTaskManagement,
    [MenuOptionsAll.HISTORY]: menuContentForHistory,
    [MenuOptionsAll.HISTORY_KENSHIN]: menuContentForKenshinHistory,
    [MenuOptionsAll.ASSIGNMENT]: menuContentForAssignment,
    [MenuOptionsAll.CONTACTS]: menuContentForContacts,
    [MenuOptionsAll.BILLING]: menuContentForBilling,
    [MenuOptionsAll.PAIDWAGE]: menuContentForPaidWage,
    [MenuOptionsAll.MYWAGE]: menuContentForMyWage,
    [MenuOptionsAll.ORGSETTINGS]: menuContentForOrganizationSettings,
    [MenuOptionsAll.ORGLOGS]: menuContentForOrganizationLogs,
    [MenuOptionsAll.MANUAL]: menuContentForManual,
    [MenuOptionsAll.SERVICETERMS]: menuContentForServiceTerms,
  };

  // To add more privilages, please add new items to the menuOptionsWithPrivilege object
  const menuOptionsWithPrivilege = {
    // Create New
    [MenuOptionsAll.NEW]: Privilege.NEW_TASK,
    [MenuOptionsAll.NEW_KENSHIN]: Privilege.NEW_TASK_KENSHIN,
    // Kanban
    [MenuOptionsAll.TASKMANAGEMENT]: Privilege.ORGANIZATION_TASK_MANAGEMENT,
    [MenuOptionsAll.TASKMANAGEMENT_KENSHIN]:
      Privilege.ORGANIZATION_TASK_MANAGEMENT_KENSHIN,
    // History
    [MenuOptionsAll.HISTORY]: Privilege.ORGANIZATION_TASK_LIST,
    [MenuOptionsAll.HISTORY_KENSHIN]: Privilege.ORGANIZATION_TASK_LIST_KENSHIN,
    [MenuOptionsAll.BILLING]: Privilege.BILLING,
    // TODO: Add new privilege for payment
    [MenuOptionsAll.PAIDWAGE]: Privilege.BILLING,
    [MenuOptionsAll.MYWAGE]: Privilege.PERSON_IN_CHARGE_AS_DOCTOR,
    [MenuOptionsAll.ASSIGNMENT]: Privilege.PERSON_IN_CHARGE_AS_DOCTOR,
    [MenuOptionsAll.ORGSETTINGS]: Privilege.ORGANIZATION_MANAGEMENT,
    [MenuOptionsAll.ORGLOGS]: Privilege.ACTIVITIES_LOG_MANAGEMENT,
  };

  const getMenuOptionsByPrivilege = () => {
    const privilege = JSON.parse(localData.get(USER_DATA.CURRENT_PRIVILEGE));
    const menuOptions = [MenuOptionsAll.CONTACTS, MenuOptionsAll.SERVICETERMS];
    const userType = localData.get(USER_DATA.USER_TYPE);

    for (const [key, value] of Object.entries(menuOptionsWithPrivilege)) {
      if (privilege[value] === PrivilegeStatus.ON) {
        menuOptions.push(key);
      }
    }
    //! There is no STAFF menu to delete for doctor
    // Remove the DOCTOR Menus if the userType is staff
    const isStaff = userType === UserType.STAFF;
    if (isStaff) {
      removeMenuOptionsIfExists(menuOptions, MenuOptionsAll.ASSIGNMENT);
      removeMenuOptionsIfExists(menuOptions, MenuOptionsAll.MYWAGE);
    }

    // Add doctor menu if userType is doctor if not already in the menuOptions
    const isDoctor = userType === UserType.DOCTOR;
    if (isDoctor) {
      if (!menuOptions.includes(MenuOptionsAll.MYWAGE)) {
        menuOptions.push(MenuOptionsAll.MYWAGE);
      }
      if (!menuOptions.includes(MenuOptionsAll.ASSIGNMENT)) {
        menuOptions.push(MenuOptionsAll.ASSIGNMENT);
      }
    }

    // Remove the ORGSSETINGS IF IS NOT OWNER
    const isOwner = localData.get(USER_DATA.IS_OWNER) === 'true';
    if (!isOwner) {
      removeMenuOptionsIfExists(menuOptions, MenuOptionsAll.ORGSETTINGS);
      removeMenuOptionsIfExists(menuOptions, MenuOptionsAll.ORGLOGS);
    }

    return menuOptions;
  };

  const removeMenuOptionsIfExists = (menuOptions, menuOptionToRemove) => {
    const indexToRemove = menuOptions.indexOf(menuOptionToRemove);
    if (indexToRemove !== -1) {
      menuOptions.splice(indexToRemove, 1);
    }
  };

  const getMenuContents = (menuOptions) => {
    const menuContents = [];
    menuOptions.forEach((option) => {
      menuContents.push(menuOptionsToContent[option]);
    });
    return menuContents;
  };

  const menuOptions = getMenuOptionsByPrivilege();
  const menuContents = getMenuContents(menuOptions);

  return menuContents;
};
